import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { ContextProvider } from "./Store/context.js";
import Home from "./Pages/home.jsx";
import AboutCourts from "./Pages/about-courts.jsx";
import OnlineService from "./Pages/online-service.jsx";
import ElectronFiling from "./Pages/online-services/electron-filing.jsx";
import News from "./Pages/news/news.jsx";
import NewsTable from "./Pages/news/id.jsx";
import Video from "./Pages/video.jsx";
import Map from "./Pages/map.jsx";
import Laws from "./Pages/law-codes/laws.jsx";
import Codex from "./Pages/law-codes/codex.jsx";
import Constitutions from "./Pages/law-codes/constitution.jsx";
import ConstitutionLaws from "./Pages/law-codes/constitutionLaws.jsx";
import LawsTable from "./Pages/law-codes-table/laws-table.jsx";
import CodexTable from "./Pages/law-codes-table/codex-table.jsx";
import ConstitutionTable from "./Pages/law-codes-table/constitution-table.jsx";
import ConstitutionLawsTable from "./Pages/law-codes-table/constitutionLaws-table.jsx";
import Gallery from "./Pages/gallery/gallery.jsx";
import ImageSlider from "./Pages/gallery/image-slider.jsx";
import Faq from "./Pages/faq.jsx";
import LawHelp from "./Pages/law-help/law-help.jsx";
import Document from "./Pages/document-sample-list/id.jsx";
import DocumentSampleList from "./Pages/document-sample-list/document-sample-list.jsx";
import CollectionDecisions from "./Pages/collection-decisions.jsx";
import StateDuty from "./Pages/state-duty.jsx";
import Footer from "./Component/footer.jsx";
import PageLoader from "./Component/loader/page-loader.js";
import ActRequest from "./Pages/online-services/act-request.jsx";
import Search from "./Pages/search/search.jsx";
import Calculator from "./Pages/calculator.jsx";
import Sale from "./Pages/sale/sale.jsx";
import Salecard from "./Pages/sale/id.jsx";
import Registration from "./Pages/auth/registration.jsx";
import Login from "./Pages/auth/login.jsx";
import Forgot from "./Pages/auth/forgot.jsx";
import Verify from "./Pages/auth/verify.jsx";
import SearchTable from "./Pages/search/search-table.jsx";
import ComplaintBoard from "./Pages/complaint-board.jsx";
import FloatingHukukAI from "./Component/FloatingHukukAI.jsx";
import CourtAI from "./Pages/ai/ai.jsx";
import { HelmetProvider } from "react-helmet-async";

function App() {
  return (
    <HelmetProvider>
      <ContextProvider>
        <Router>
          <Main />
        </Router>
      </ContextProvider>
    </HelmetProvider>
  );
}

const Main = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const isCourtAI = location.pathname === "/court-ai";

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, [location]);

  useEffect(() => {
    const handleStart = () => setLoading(true);
    const handleComplete = () => setLoading(false);
    handleStart();
    const timer = setTimeout(handleComplete, 500);
    return () => clearTimeout(timer);
  }, [location]);

  useEffect(() => {
    const pagePath = location.pathname + location.search;
    if (window.gtag) {
      window.gtag("config", "G-9E7SN4BY2X", {
        page_path: pagePath,
      });
    }
  }, [location]);

  return (
    <div className="h-screen grid grid-rows-layout font-century">
      {loading && <PageLoader />}
      {/* <Navbar /> */}
      <div>
        <Routes>
          <Route path='/*' element={<SubRoutes />} />
        </Routes>
      </div>
      {!isCourtAI && <Footer />}
      {!isCourtAI && <FloatingHukukAI />}
    </div>
  );
};

const SubRoutes = () => (
  <Routes>
    <Route index element={<Home />} />
    <Route path='laws-codes/laws' element={<Laws />} />
    <Route path='laws-codes/codex' element={<Codex />} />
    <Route path='laws-codes/constitution' element={<Constitutions />} />
    <Route path='laws-codes/constitutionlaws' element={<ConstitutionLaws />} />
    <Route path='laws/:id' element={<LawsTable />} />
    <Route path='codex/:id' element={<CodexTable />} />
    <Route path='constitution/:id' element={<ConstitutionTable />} />
    <Route path='constitutionlaws/:id' element={<ConstitutionLawsTable />} />
    <Route path='about' element={<AboutCourts />} />
    <Route path='faq' element={<Faq />} />
    <Route path='complaint-board/:id' element={<ComplaintBoard />} />
    <Route path='law-help' element={<LawHelp />} />
    <Route path='online-service' element={<OnlineService />} />
    <Route path='electron-filing' element={<ElectronFiling />} />
    <Route path='act-request' element={<ActRequest />} />
    <Route path='document-sample-list' element={<DocumentSampleList />} />
    <Route path='document-sample-list/:id' element={<Document />} />
    <Route path='collection-decisions' element={<CollectionDecisions />} />
    <Route path='state-duty' element={<StateDuty />} />
    <Route path='calculator' element={<Calculator />} />
    <Route path='sale' element={<Sale />} />
    <Route path='sale/:id' element={<Salecard />} />
    <Route path='news/table' element={<News />} />
    <Route path='news/:id' element={<NewsTable />} />
    <Route path='gallery' element={<Gallery />} />
    <Route path='images/:id' element={<ImageSlider />} />
    <Route path='video' element={<Video />} />
    <Route path='map' element={<Map />} />
    <Route path='search' element={<Search />} />
    <Route path='search-law' element={<SearchTable />} />
    <Route path='auth/registration' element={<Registration />} />
    <Route path='auth/login' element={<Login />} />
    <Route path='auth/forgot' element={<Forgot />} />
    <Route path='auth/verify' element={<Verify />} />
    <Route path="court-ai" element={<CourtAI />} />
  </Routes>
);

export default App;
